import Hero from '../Hero/Hero';
import Problem from '../Problem/Problem';
import Solution from '../Solution/Solution';
import Benefits from '../Benefits/Benefits';
import Products from '../Products/Products';
import Needs from '../Needs/Needs';
import HowToBuy from '../HowToBuy/HowToBuy';
import Education from '../Education/Education';
import SocialProof from '../SocialProof/SocialProof';
import Location from '../Location/Location';
import FinalCTA from '../FinalCTA/FinalCTA';
import StickyWhatsApp from '../StickyWhatsApp/StickyWhatsApp';
import Footer from '../Footer/Footer';

function Home() {
  return (
    <main>
      <Hero />
      <Problem />
      <Solution />
      <Benefits />
      <Products />
      <Needs />
      <HowToBuy />
      <Education />
      <SocialProof />
      <Location />
      <FinalCTA />
      <StickyWhatsApp />
      <Footer />
    </main>
  );
}

export default Home;
